<script lang="ts">
  import { onMount, getContext } from "svelte";
  import { page } from "$app/stores";
  import Footer from "$lib/views/Footer.svelte";
  //export let data: any;
  export let blok: any;
  let loaded = false;
  const footerNavigation = getContext("footerNavigation");
  const socials = getContext("socials");
  const footerBottomLinks = getContext("footerBottomLinks");
  // const applyUrl = `https://boards.greenhouse.io/embed/job_app?for=flyzipline&token=${data.id}#application`;

  onMount(() => {
    let slug = $page.params.slug || "";
    let JOB_ID = parseInt(slug.split("/").reverse()[0]);
    if (isNaN(JOB_ID)) return;

    window.jobId = JOB_ID;

    var Grnhse = Grnhse || {};
    Grnhse.Settings = {
      targetDomain: "https://boards.greenhouse.io",
      scrollOnLoad: true,
      autoLoad: true,
      boardURI: "https://boards.greenhouse.io/embed/job_board?for=flyzipline",
      applicationURI:
        "https://boards.greenhouse.io/embed/job_app?for=flyzipline",
      baseURI: "https://flyzipline.com/careers/",
      iFrameWidth: "100%",
    };
    Grnhse.Const = {
      JOB_ID: "gh_jid",
      SOURCE_TOKEN: "gh_src",
      PROGRAMMATIC_SOURCING_TRACKING: "ccuid",
    };
    Grnhse.Config = {
      IframeDefault: {
        id: "grnhse_iframe",
        width: Grnhse.Settings.iFrameWidth,
        frameborder: "0",
        scrolling: "no",
        allow: "geolocation",
        onload: undefined,
        title: "Greenhouse Job Board",
      },
    };
    Grnhse.Route = {
      boardUrl: function (source) {
        var helper = Grnhse.UriHelper,
          settings = Grnhse.Settings,
          params = [];
        if (source) {
          params.push("t=" + source);
        }
        return helper.appendParams(settings.boardURI, params);
      },
      applicationUrl: function (source, jobId, ccuid) {
        var helper = Grnhse.UriHelper,
          settings = Grnhse.Settings,
          params = [];
        if (source) {
          params.push("t=" + source);
        }
        if (jobId) {
          params.push("token=" + jobId);
        }
        if (ccuid) {
          params.push("ccuid=" + ccuid);
        }
        return helper.appendParams(settings.applicationURI, params);
      },
    };
    Grnhse.UriHelper = {
      base: function () {
        var uriHelper = Grnhse.UriHelper,
          location = uriHelper.currentLocation(),
          settings = Grnhse.Settings;
        return window && location
          ? uriHelper.pathFromLocation(location)
          : settings.boardURI;
      },
      currentLocation: function () {
        return window.top.location;
      },
      getParam: function (name) {
        var location = Grnhse.UriHelper.currentLocation(),
          uri = location.href,
          start = uri.indexOf(name),
          end;
        if (start === -1) {
          return null;
        }
        start += name.length + 1;
        end = uri.substr(start).search(/(&|#|$|;)/);
        return uri.substr(start, end);
      },
      appendParams: function (url, params) {
        params.push("b=" + Grnhse.UriHelper.base());
        url += url.indexOf("?") === -1 ? "?" : "&";
        return url + params.join("&");
      },
      pathFromLocation: function (location) {
        return encodeURIComponent(
          location.protocol + "//" + location.host + location.pathname,
        );
      },
    };
    Grnhse.BrowserHelper = {
      supportsPostMessage: function () {
        return !(document.all && !window.atob);
      },
    };
    Grnhse.Iframe = function (src, overrides) {
      let loaded = true;

      var settings = Grnhse.Settings,
        self = this;
      overrides = overrides || {};
      this.config = Grnhse.Config.IframeDefault;
      this.config.src = src;
      this.supportAwfulBrowsers();
      overrides["onload"] = settings.scrollOnLoad
        ? "window.scrollTo(0,0)"
        : undefined;
      mergeOverrides.call(this);
      this.registerEventHandlers();
      this.htmlElement = this.build();
      this.render();

      function mergeOverrides() {
        for (var override in overrides) {
          if (Object.hasOwn(overrides, override)) {
            self.config[override] = overrides[override];
          }
        }
      }
    };
    Grnhse.Iframe.prototype.build = function () {
      var iframe = document.createElement("iframe"),
        config = this.config;
      for (var key in config) {
        if (Object.hasOwn(config, key)) {
          iframe.setAttribute(key, config[key]);
        }
      }
      return iframe;
    };
    Grnhse.Iframe.prototype.render = function () {
      var container = document.getElementById("grnhse_app");
      container.innerHTML = "";
      container.appendChild(this.htmlElement);
    };
    Grnhse.Iframe.prototype.registerEventHandlers = function () {
      var instance = this,
        resizeEvent = null;
      if (window.addEventListener) {
        window.addEventListener("message", resize, false);
        window.addEventListener("resize", windowResize, false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", resize);
        window.attachEvent("onresize", windowResize);
      }

      function windowResize(e) {
        // Pass resize event from parent window to iframe
        clearTimeout(resizeEvent);
        resizeEvent = setTimeout(triggerResize, 200);
      }

      function triggerResize() {
        if (window.postMessage && instance.htmlElement) {
          instance.htmlElement.contentWindow.postMessage("resize", "*");
        }
      }

      function resize(e) {
        if (
          instance.htmlElement &&
          e.origin === Grnhse.Settings.targetDomain &&
          e.data > 0
        ) {
          instance.htmlElement.setAttribute("height", e.data);
        }
      }
    };
    Grnhse.Iframe.prototype.supportAwfulBrowsers = function () {
      var browserHelper = Grnhse.BrowserHelper;
      if (!browserHelper.supportsPostMessage()) {
        this.config["scrolling"] = "yes";
        this.config["height"] = 1000;
      }
    };
    Grnhse.Iframe.load = function (jobId, source, ccuid) {
      var r = Grnhse.Route,
        uriHelper = Grnhse.UriHelper,
        jobId = jobId || uriHelper.getParam(Grnhse.Const.JOB_ID),
        source = source || uriHelper.getParam(Grnhse.Const.SOURCE_TOKEN),
        ccuid =
          ccuid ||
          uriHelper.getParam(Grnhse.Const.PROGRAMMATIC_SOURCING_TRACKING),
        viewingApplication = !!jobId,
        pathToLoad = viewingApplication
          ? r.applicationUrl(source, jobId, ccuid)
          : r.boardUrl(source);
      return new Grnhse.Iframe(pathToLoad);
    };

    window._grnhse = window._grnhse || {};
    _grnhse.load = Grnhse.Iframe.load;
    Grnhse.Iframe.autoLoad = function () {
      Grnhse.Iframe.load(JOB_ID);
    };

    (function () {
      if (Grnhse.Settings.autoLoad) {
        Grnhse.Iframe.autoLoad();
      }
    })();
  });
</script>

<div class="section-header-width mx-auto mt-[60px] md:mt-[80px] lg:mt-[100px]">
  <div class="max-w-[792px] mx-auto">
    <div id="grnhse_app"></div>
  </div>
</div>

<!--
<div class="section-max-width mx-auto -mt-[80px] [@media(min-width:661px)]:mt-0 lg:max-w-[974px]">
	<div class="px-[10px] [@media(min-width:661px)]:pl-0 [@media(min-width:661px)]:-ml-[10px] md:!pl-[10px] md:!pr-[20px] md:!ml-0"><div class="" id="grnhse_app"></div></div>
	<div class="px-[10px] [@media(min-width:661px)]:pl-0 [@media(min-width:661px)]:-ml-[10px] md:!pl-[10px] md:!pr-[20px] md:!ml-0"><div class="" id="grnhse_app"></div></div>
</div> -->

<Footer
  theme={"light"}
  categories={blok.footer_categories}
  {socials}
  {footerBottomLinks}
  navigation={footerNavigation}
/>

<style lang="scss">
  /* :global(.job-content span[style]) {
		font-weight: 300 !important;
	}
	:global(.job-content .section) {
		padding: 0 0 0 0 !important;
	}
	:global(.job-content h3) {
		margin-top: 4rem;
		margin-bottom: 1rem;
		@apply text-[#242021];
	}

	:global(.job-content ol) {
		list-style-type: decimal;
		padding-left: 1em;
	}

	:global(.job-content ul) {
		list-style-type: disc;
		padding-left: 1em;
	}
	:global(.job-content ul li ul) {
		list-style-type: circle;
		@apply mt-2;
	}

	:global(.job-content > ul > li:not(:last-of-type)) {
		@apply pb-4 mb-4;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	} */
</style>
